import { Transition, Variants } from "framer-motion";

const transition: Transition = {
  ease: "easeOut",
  damping: 35,
  stiffness: 100,
  duration: 0.5,
  delay: 0.1,
};

export const variantFadeIn: Variants = {
  visible: {
    opacity: 1,
    transition,
  },
  hidden: {
    opacity: 0,
    transition,
  },
};
